// Generated by scripts/build-canonical.ts from src/data/source/*.json.
// Do not edit by hand — re-run the script to refresh. This is schema v2 (canonical items
// catalog) — it coexists with the legacy per-category files, it does not replace them yet.

import { CANONICAL_ITEMS } from "./items";

export const ITEMS_BY_ID: Record<string, (typeof CANONICAL_ITEMS)[number]> =
  Object.fromEntries(CANONICAL_ITEMS.map((item) => [item.id, item]));

export const ITEM_IDS_BY_KIND: Record<string, string[]> = {
  "fish": [
    "anglerfish",
    "arctic-char",
    "atlantic-mackerel",
    "atlantic-pygmy-octopus",
    "atlantic-salmon",
    "barbel",
    "beltfish",
    "blackspot-seabream",
    "blue-european-crayfish",
    "bluefin-tuna",
    "bluegill",
    "burbot",
    "butterfly-koi",
    "chum-salmon",
    "clownfish",
    "common-barbel",
    "common-bleak",
    "common-carp",
    "common-chub",
    "common-octopus",
    "common-prawn",
    "common-rudd",
    "common-shrimp",
    "common-whitefish",
    "crucian-carp",
    "director-common-octopus-w-cinnamon-hat",
    "director-pygmy-octopus-w-brown-hat",
    "director-pygmy-octopus-w-cyan-hat",
    "director-pygmy-octopus-w-navy-hat",
    "edible-frog",
    "european-crayfish",
    "european-eel",
    "european-flying-squid",
    "european-lobster",
    "european-mudminnow",
    "european-perch",
    "european-plaice",
    "european-smelt",
    "false-scad",
    "freshwater-blenny",
    "frostspore-king-crab",
    "frostspore-ocean-sunfish",
    "frostspore-puffer-fish",
    "frostspore-seahorse",
    "frostspore-whale-shark",
    "giant-oarfish",
    "goby",
    "golden-king-crab",
    "goldfish",
    "grayling",
    "haddock",
    "hermit-crab",
    "horse-mackerel",
    "huchen",
    "king-crab",
    "large-pearl-mussel",
    "largemouth-bass",
    "mediterranean-killifish",
    "minnow",
    "moonfish",
    "mottled-sculpin",
    "mud-sunfish",
    "mussel",
    "northern-pike",
    "nursehound",
    "ocean-sunfish",
    "oriental-shrimp",
    "puffer-fish",
    "pumpkinseed",
    "rabbit-fish",
    "red-bellied-piranha",
    "river-crab",
    "ruffe",
    "sardine",
    "scad",
    "schneider",
    "sea-bass",
    "sea-stickleback",
    "seahorse",
    "shortfin-mako-shark",
    "skipjack-tuna",
    "smooth-hammerhead",
    "spined-loach",
    "stone-loach",
    "streber",
    "striped-red-mullet",
    "swordfish",
    "tadpole",
    "tench",
    "three-spined-stickleback",
    "tilapia",
    "trout",
    "tub-gurnard",
    "turbot",
    "wels-catfish",
    "zander",
    "director-common-octopus-with-patterned-hat",
    "asian-arowana",
    "blackspot-sergeant",
    "lionhead",
    "whale-shark",
    "mahi-mahi",
    "moon-jelly",
    "angelfish",
    "pink-betta",
    "green-sea-turtle",
    "white-faced-surgeonfish",
    "lionfish",
    "blue-and-yellow-wrasse",
    "azure-demoiselle",
    "blue-brick-clownfish",
    "colorful-brick-clownfish",
    "purple-brick-clownfish",
    "red-brick-clownfish",
    "green-brick-clownfish",
    "american-paddlefish",
    "amur-catfish",
    "apple-hermit-crab",
    "bandage-fish",
    "bath-towel-mako-shark",
    "black-diamond-mussel",
    "blue-diamond-mussel",
    "blue-jello-fish",
    "blue-light-jellyfish",
    "blue-red-betta",
    "blueberry-hermit-crab",
    "brown-sauna-hat-sea-turtle",
    "candy-corn-fish",
    "clockwork-frog",
    "dragonfruit-hermit-crab",
    "firefly-squid",
    "flatback-turtle",
    "ghost-frog",
    "gin-matsuba-koi",
    "golden-koi",
    "golden-mussel",
    "green-bath-towel-mako-shark",
    "green-jello-fish",
    "green-light-jellyfish",
    "green-light-sea-star",
    "indigo-jello-fish",
    "jade-mussel",
    "japanese-flying-squid",
    "jello-fish",
    "kissing-fish",
    "koi",
    "light-sea-star",
    "mandarin-fish",
    "mandarin-hermit-crab",
    "olive-ridley-turtle",
    "orange-jello-fish",
    "permit",
    "pink-atlantic-salmon",
    "pink-king-crab",
    "pink-seahorse",
    "pink-shortfin-mako-shark",
    "pink-swordfish",
    "purple-diamond-mussel",
    "purple-jello-fish",
    "purple-light-jellyfish",
    "purple-light-sea-star",
    "raspberry-hermit-crab",
    "red-jello-fish",
    "red-koi",
    "sauna-hat-sea-turtle",
    "scallop",
    "sea-slug",
    "spectral-octopus",
    "striped-bath-towel-mako-shark",
    "striped-sauna-hat-sea-turtle",
    "tiger-puffer",
    "white-sauna-hat-sea-turtle",
    "yellow-bath-towel-mako-shark"
  ],
  "insect": [
    "alpine-longhorn-beetle",
    "amethyst-flower-beetle",
    "ant",
    "apollo",
    "asian-lady-beetle",
    "asparagus-beetle",
    "bagworm-moth",
    "beautiful-demoiselle",
    "beautiful-leopard",
    "blue-morpho",
    "blue-shieldbug",
    "bumblebee",
    "cabbage-white",
    "cerulean-carpenter",
    "chestnut-tiger",
    "cicada",
    "comet-moth",
    "common-blue-butterfly",
    "common-brimstone",
    "common-whitetail",
    "conehead-mantis",
    "crimson-marsh-glider",
    "elegant-flower-beetle",
    "european-firebug",
    "fire-colored-beetle",
    "four-spotted-ladybug",
    "four-spotted-skimmer",
    "frostspore-mother-of-pearl",
    "frostspore-postman-butterfly",
    "frostspore-purple-spotted-swallowtail",
    "frostspore-queen-alexandras-birdwing",
    "frostspore-sulkowskys-morpho",
    "giant-asian-mantis",
    "gold-grasshopper",
    "golden-jewel-scarab",
    "golden-stag-beetle",
    "green-birdwing",
    "green-script-supervisor-bumblebee",
    "green-tiger-beetle",
    "hercules-beetle",
    "horned-beetle",
    "katydid",
    "large-banded-grasshopper",
    "large-red-damselfly",
    "mediterranean-mantis",
    "mini-moon-moth",
    "minotaur-beetle",
    "morpho-helena",
    "mother-of-pearl",
    "mourning-cloak",
    "old-world-swallowtail",
    "orange-tip",
    "peacock-butterfly",
    "picasso-bug",
    "pink-katydid",
    "pink-script-supervisor-bumblebee",
    "postman-butterfly",
    "purple-emperor",
    "purple-script-supervisor-bumblebee",
    "rainbow-stag-beetle",
    "rajah-brookes-birdwing",
    "red-script-supervisor-bumblebee",
    "seven-spotted-ladybug",
    "siberian-grasshopper",
    "silver-jewel-scarab",
    "spanish-moon-moth",
    "splay-footed-carpenter",
    "stag-beetle",
    "sulkowskys-morpho",
    "sunset-morpho",
    "waroona-cuckoo-bee",
    "wasp-beetle",
    "white-witch",
    "golden-script-supervisor-bumblebee",
    "yellow-brick-large-red-damselfly",
    "blue-brick-large-red-damselfly",
    "purple-brick-large-red-damselfly",
    "colorful-brick-large-red-damselfly",
    "pink-brick-large-red-damselfly",
    "atlas-beetle",
    "orchid-mantis",
    "queen-alexandra-s-birdwing",
    "greater-asian-lady-beetle",
    "goliath-beetle",
    "red-milkweed-locust",
    "flamer-skimmer",
    "purple-spotted-swallowtail",
    "scarce-morpho",
    "green-metalwing",
    "green-snail",
    "glasswing-butterfly",
    "agrias-butterfly",
    "balloon-morpho",
    "balloon-nymphalidae",
    "balloon-swallowtail",
    "blue-dung-beetle",
    "blue-floating-dust-bug",
    "blue-light-firefly",
    "blue-milkweed-beetle",
    "clockwork-ladybug",
    "coal-bug",
    "crawling-firecracker-bug",
    "dung-beetle",
    "dust-bug",
    "eastern-lubber-grasshopper",
    "firecracker-bug",
    "flame-skimmer",
    "flying-firecracker-bug",
    "gold-bug",
    "golden-clockwork-ladybug",
    "golden-dung-beetle",
    "gray-bouncy-dust-insect",
    "great-black-firefly",
    "green-bouncy-dust-bug",
    "green-dung-beetle",
    "green-flower-chafer",
    "green-light-firefly",
    "hanging-firecracker-bug",
    "ice-bug",
    "indigo-hanging-dust-bug",
    "jelly-treatsure-firefly",
    "jellybean-treatsure-butterfly",
    "jumping-firecracker-bug",
    "light-firefly",
    "lollipop-treatsure-dragonfly",
    "lychee-shieldbug",
    "morpho-luna",
    "palmier-treatsure-butterfly",
    "pink-hanging-dust-bug",
    "pink-light-firefly",
    "pink-necked-firefly",
    "psionic-indian-fritillary",
    "psionic-luna-moth",
    "psionic-queen-alexandra-s-birdwing",
    "psionic-rimmed-window-firefly",
    "puff-treatsure-ladybug",
    "purple-dung-beetle",
    "purple-floating-dust-bug",
    "purple-light-firefly",
    "rajah-brooke-s-birdwing",
    "red-clockwork-ladybug",
    "red-dung-beetle",
    "rimmed-window-firefly",
    "rock-bug",
    "roll-cake-treatsure-snail",
    "snow-bug",
    "snowy-window-firefly",
    "sulkowsky-s-morpho",
    "white-banded-erebus-moth",
    "white-clockwork-ladybug",
    "yellow-clockwork-ladybug",
    "yellow-light-firefly"
  ],
  "bird": [
    "african-olive-pigeon",
    "american-flamingo",
    "amur-falcon",
    "audouins-gull",
    "azores-bullfinch",
    "azure-tit",
    "bearded-reedling",
    "blue-and-yellow-macaw",
    "blue-peafowl",
    "brown-noddy",
    "cinnamon-ground-dove",
    "common-kestrel",
    "double-barred-finch",
    "eagle-owl",
    "eastern-bluebird",
    "eurasian-bullfinch",
    "eurasian-chaffinch",
    "eurasian-collared-dove",
    "eurasian-golden-oriole",
    "eurasian-nuthatch",
    "eurasian-wigeon",
    "eurasian-wren",
    "european-bee-eater",
    "european-robin",
    "european-shag",
    "great-green-macaw",
    "great-tit",
    "greater-flamingo",
    "hawfinch",
    "imperial-shag",
    "jambu-fruit-dove",
    "king-eider",
    "lady-amherst-pheasant",
    "lears-macaw",
    "lesser-flamingo",
    "long-eared-owl",
    "long-tailed-tit",
    "mallard",
    "paradise-tanager",
    "peregrine-falcon",
    "pied-imperial-pigeon",
    "pine-grosbeak",
    "pink-necked-green-pigeon",
    "pink-pigeon",
    "przevalskis-parrotbill",
    "red-and-green-macaw",
    "red-faced-cormorant",
    "redpoll",
    "regent-bowerbird",
    "ruddy-shelduck",
    "seagull",
    "silver-throated-tit",
    "smew",
    "stock-dove",
    "tern",
    "verditer-flycatcher",
    "wallaces-fruit-dove",
    "white-headed-duck",
    "white-wagtail",
    "winter-eurasian-wigeon",
    "winter-greater-flamingo",
    "winter-mallard",
    "winter-mandarin-duck",
    "winter-smew",
    "wonga-pigeon",
    "woodchat-shrike",
    "yellow-bellied-flycatcher",
    "blue-brick-sparrow",
    "purple-brick-sparrow",
    "colorful-brick-sparrow",
    "pink-brick-sparrow",
    "green-brick-sparrow",
    "blue-suit-dove",
    "gray-suit-dove",
    "striped-suit-dove",
    "red-suit-dove",
    "green-suit-dove",
    "green-peafowl",
    "white-peafowl",
    "black-peafowl",
    "baikal-teal",
    "inca-tern",
    "chestnut-cheeked-starling",
    "blue-headed-quail-dove",
    "snowy-owl",
    "red-browed-finch",
    "atlantic-puffin",
    "blue-footed-booby",
    "whooper-swan",
    "black-swan",
    "black-stork",
    "spectacled-owl",
    "audouin-s-gull",
    "black-turkey",
    "blue-camping-sparrow",
    "blue-clockwork-sparrow",
    "blue-hat-stock-dove",
    "blue-starry-stock-dove",
    "blue-starry-swan",
    "bourbon-red-turkey",
    "brown-camping-sparrow",
    "brown-clockwork-sparrow",
    "brown-hat-stock-dove",
    "camping-sparrow",
    "clockwork-sparrow",
    "golden-pheasant",
    "gray-camping-sparrow",
    "gray-clockwork-sparrow",
    "green-camping-sparrow",
    "green-hat-stock-dove",
    "green-starry-stock-dove",
    "green-starry-swan",
    "grey-mantled-albatross",
    "inflatable-mallard",
    "inflatable-ruddy-shelduck",
    "inflatable-smew",
    "inflatable-wigeon",
    "lady-amherst-s-pheasant",
    "little-egret",
    "mandarin-duck",
    "ocellated-turkey",
    "orange-camping-sparrow",
    "oriental-magpie",
    "pied-falconet",
    "pied-kingfisher",
    "pink-hat-stock-dove",
    "pomarine-skua",
    "purple-starry-stock-dove",
    "purple-starry-swan",
    "red-crowned-crane",
    "roseate-spoonbill",
    "royal-palm-turkey",
    "starry-swan",
    "turkey",
    "wandering-albatross",
    "white-faced-storm-petrel",
    "white-hat-stock-dove",
    "white-spoonbill",
    "white-winged-tern"
  ],
  "crop": [
    "avocado",
    "cacao",
    "carrot",
    "corn",
    "eggplant",
    "grape",
    "lettuce",
    "paddy",
    "pineapple",
    "potatoes",
    "romaine-lettuce",
    "strawberry",
    "tea",
    "tomato",
    "wheat",
    "white-radish"
  ],
  "flower": [
    "anthurium",
    "calla-lily",
    "black-calla-lily",
    "orange-calla-lily",
    "peach-calla-lily",
    "pink-calla-lily",
    "purple-calla-lily",
    "red-calla-lily",
    "sunglow-calla-lily",
    "sunglow-highland-poppy",
    "white-calla-lily",
    "yellow-calla-lily",
    "carnation",
    "black-carnation",
    "green-carnation",
    "orange-carnation",
    "peach-carnation",
    "pink-carnation",
    "red-carnation",
    "selene-carnation",
    "white-carnation",
    "yellow-carnation",
    "corn-poppy",
    "red-corn-poppy",
    "white-corn-poppy",
    "yellow-corn-poppy",
    "black-corn-poppy",
    "orange-corn-poppy",
    "pink-corn-poppy",
    "purple-corn-poppy",
    "cranesbill",
    "daisy",
    "green-daisy",
    "pink-daisy",
    "red-daisy",
    "selene-daisy",
    "white-daisy",
    "dandelion",
    "highland-poppy",
    "black-highland-poppy",
    "blue-highland-poppy",
    "green-highland-poppy",
    "orange-highland-poppy",
    "peach-highland-poppy",
    "pink-highland-poppy",
    "red-highland-poppy",
    "selene-highland-poppy",
    "white-highland-poppy",
    "yellow-highland-poppy",
    "hyacinth",
    "laceleaf",
    "green-laceleaf",
    "orange-laceleaf",
    "peach-laceleaf",
    "pink-laceleaf",
    "red-laceleaf",
    "white-laceleaf",
    "yellow-laceleaf",
    "lily",
    "black-lily",
    "green-lily",
    "orange-lily",
    "peach-lily",
    "pink-lily",
    "purple-lily",
    "red-lily",
    "selene-lily",
    "white-lily",
    "yellow-lily",
    "morning-glory",
    "selene-morning-glory",
    "black-morning-glory",
    "orange-morning-glory",
    "peach-morning-glory",
    "pink-morning-glory",
    "purple-morning-glory",
    "red-morning-glory",
    "white-morning-glory",
    "moth-orchid",
    "pansy",
    "black-pansy",
    "orange-pansy",
    "purple-pansy",
    "sunglow-pansy",
    "yellow-pansy",
    "rose",
    "black-rose",
    "blue-rose",
    "orange-rose",
    "peach-rose",
    "pink-rose",
    "purple-rose",
    "selene-rose",
    "sunglow-rose",
    "white-rose",
    "yellow-rose",
    "tulip",
    "black-tulip",
    "blue-tulip",
    "orange-tulip",
    "peach-tulip",
    "pink-tulip",
    "purple-tulip",
    "sunglow-tulip",
    "white-tulip",
    "yellow-tulip",
    "black-cranesbill",
    "black-dandelion",
    "black-hyacinth",
    "black-moth-orchid",
    "blue-cranesbill",
    "blue-dandelion",
    "blue-hyacinth",
    "blue-moth-orchid",
    "green-cranesbill",
    "orange-cranesbill",
    "orange-dandelion",
    "orange-hyacinth",
    "orange-moth-orchid",
    "peach-cranesbill",
    "peach-dandelion",
    "peach-hyacinth",
    "peach-moth-orchid",
    "pink-cranesbill",
    "pink-dandelion",
    "pink-hyacinth",
    "pink-moth-orchid",
    "purple-dandelion",
    "purple-hyacinth",
    "purple-moth-orchid",
    "red-cranesbill",
    "red-dandelion",
    "red-hyacinth",
    "red-moth-orchid",
    "selene-cranesbill",
    "selene-dandelion",
    "selene-moth-orchid",
    "sunglow-cranesbill",
    "sunglow-hyacinth",
    "sunglow-moth-orchid",
    "white-cranesbill",
    "white-dandelion",
    "white-hyacinth",
    "white-moth-orchid",
    "yellow-cranesbill",
    "yellow-dandelion",
    "yellow-hyacinth",
    "yellow-moth-orchid"
  ],
  "forageable": [
    "apple",
    "bamboo",
    "bizarre-button-mushroom-blue",
    "bizarre-button-mushroom-green",
    "bizarre-button-mushroom-red",
    "bizarre-oyster-mushroom-orange",
    "bizarre-oyster-mushroom-pink",
    "bizarre-oyster-mushroom-purple",
    "bizarre-penny-bun-pink",
    "bizarre-penny-bun-purple",
    "bizarre-penny-bun-red",
    "bizarre-shiitake-blue",
    "bizarre-shiitake-black",
    "bizarre-shiitake-red",
    "black-truffle",
    "blueberry",
    "branch",
    "burdock",
    "button-mushroom",
    "fiddlehead",
    "flawless-fluorite",
    "mandarin",
    "matsutake",
    "mustard-greens",
    "orange",
    "oyster-mushroom",
    "penny-bun",
    "quality-timber",
    "rare-timber",
    "raspberry",
    "roaming-oak-timber",
    "shiitake",
    "stone",
    "tall-mustard",
    "timber",
    "weed"
  ],
  "animal": [
    "bunny",
    "capybara",
    "deer",
    "ferret",
    "fox",
    "llama",
    "penguin",
    "panda",
    "sea-otter"
  ],
  "dish": [
    "afternoon-tea",
    "apple-jam",
    "apple-pie",
    "baked-eggplant-w-meat",
    "bizarre-food",
    "bizzare-drink",
    "black-truffle-cream-pasta",
    "black-truffle-pie",
    "blue-roll-cake",
    "blueberry-jam",
    "button-mushroom-pie",
    "candlelight-dinner",
    "caramel-popcorn-bucket",
    "carrot-cake",
    "cheese-cake",
    "chocolate-sauce",
    "coffee",
    "coffee-latte",
    "colorful-movie-combo",
    "corn-soup",
    "crayfish-sashimi",
    "deluxe-seafood-platter",
    "fish-and-chips",
    "fish-n-chips",
    "grape-jam",
    "green-roll-cake",
    "grilled-button-mushroom",
    "grilled-mushrooms",
    "grilled-oyster-mushroom",
    "grilled-penny-bun",
    "grilled-shiitake-mushroom",
    "house-salad",
    "indigo-roll-cake",
    "latte",
    "mandarin-jam",
    "meat-burger",
    "meat-sauce-pasta",
    "mixed-jam",
    "mushroom-pie",
    "onsen-egg",
    "orange-roll-cake",
    "original-roll-cake",
    "oyster-mushroom-pie",
    "penny-bun-pie",
    "picnic-set",
    "pineapple-jam",
    "raspberry-jam",
    "red-roll-cake",
    "romaine-lettuce-taco",
    "rustic-ratatouille",
    "salsa-wavy-potato-chips",
    "savory-double-combo-bucket",
    "savory-popcorn-bucket",
    "seafood-pizza",
    "seafood-risotto",
    "shiitake-pie",
    "smoked-fish-bagel",
    "tiramisu",
    "tomato-sauce",
    "violet-roll-cake",
    "wild-bracken-celtuce-taco",
    "wild-burdock-celtuce-taco",
    "wild-garlic-mustard-celtuce-taco",
    "wild-mustard-greens-celtuce-taco",
    "wild-vegetable-celtuce-taco",
    "winter-frost-season-apple-frosted-pancake",
    "winter-frost-season-aurora-banquet",
    "winter-frost-season-blueberry-frosted-pancake",
    "winter-frost-season-creamy-white-radish-soup",
    "winter-frost-season-iced-coffee",
    "winter-frost-season-iced-latte",
    "winter-frost-season-mandarin-frosted-pancake",
    "winter-frost-season-original-frosted-pancake",
    "winter-frost-season-raspberry-frosted-pancake",
    "winter-frost-season-steak-w-mashed-white-radish",
    "yellow-roll-cake",
    "apple-verbena-pie",
    "blueberry-verbena-pie",
    "brick-black-truffle-patty-burger",
    "brick-bowl-apple-shaved-ice",
    "brick-bowl-blueberry-shaved-ice",
    "brick-bowl-fruit-shaved-ice",
    "brick-bowl-grape-shaved-ice",
    "brick-bowl-mandarin-shaved-ice",
    "brick-bowl-pineapple-shaved-ice",
    "brick-bowl-raspberry-shaved-ice",
    "brick-bowl-strawberry-shaved-ice",
    "brick-button-mushroom-patty-burger",
    "brick-fun-combo-set",
    "brick-mushroom-patty-burger",
    "brick-oyster-mushroom-patty-burger",
    "brick-penny-bun-patty-burger",
    "brick-shiitake-patty-burger",
    "colorful-egg-feast",
    "fruit-verbena-pie",
    "grape-verbena-pie",
    "grass-cake",
    "green-egg",
    "heart-puppies-con-panna",
    "maltese-canele",
    "maltese-con-panna",
    "mandarin-verbena-pie",
    "orange-egg",
    "pillow-shaped-egg-yolk-and-pork-zongzi",
    "pillow-shaped-plain-rice-zongzi",
    "pillow-shaped-red-bean-zongzi",
    "pineapple-verbena-pie",
    "purple-egg",
    "rainbow-heart",
    "rainbow-spark",
    "raspberry-verbena-pie",
    "retriever-canele",
    "retriever-con-panna",
    "springdag-raspberry-black-tea",
    "springday-apple-black-tea",
    "springday-blueberry-black-tea",
    "springday-fruit-black-tea",
    "springday-grape-black-tea",
    "springday-mandarin-black-tea",
    "springday-pineapple-black-tea",
    "springday-strawberry-black-tea",
    "strawberry-jam",
    "strawberry-verbena-pie",
    "supreme-movie-meal",
    "triangle-egg-yolk-and-pork-zongzi",
    "triangle-plain-rice-zongzi",
    "triangle-red-bean-zongzi",
    "blue-european-crayfish-sashimi",
    "steamed-golden-king-crab",
    "steamed-king-crab",
    "apple-milkshake",
    "blueberry-milkshake",
    "cocoa-milk-tea",
    "cocoa-milkshake",
    "grape-milkshake",
    "mandarin-milkshake",
    "matcha-milkshake",
    "mellow-black-tea",
    "mellow-milk-tea",
    "milkshake",
    "pineapple-milkshake",
    "raspberry-milkshake",
    "strawberry-milkshake",
    "daisy-tea",
    "exquisite-afternoon-tea",
    "green-milk-tea",
    "green-tea",
    "matcha-green-milk-tea",
    "rose-tea",
    "alpaca-cupcake",
    "apple-cake",
    "apple-cloud-candy",
    "apple-frosted-pancake",
    "apple-ice-cream",
    "apple-jam-meatball",
    "apple-juice",
    "apple-pearl-cake",
    "apple-princess-cake",
    "apple-pudding",
    "aurora-banquet",
    "baked-eggplant-w-meat-sauce",
    "bamboo-tube-apple-juice",
    "bamboo-tube-blueberry-juice",
    "bamboo-tube-dragonfruit-juice",
    "bamboo-tube-juice",
    "bamboo-tube-mandarin-juice",
    "bamboo-tube-raspberry-juice",
    "bean-paste-tangyuan",
    "berry-cake",
    "berry-pie",
    "blue-coast",
    "blueberry-cloud-candy",
    "blueberry-frosted-pancake",
    "blueberry-ice-cream",
    "blueberry-jam-meatball",
    "blueberry-juice",
    "blueberry-pearl-cake",
    "blueberry-princess-cake",
    "blueberry-pudding",
    "blueberry-toast",
    "bottled-apple-juice",
    "bottled-blueberry-juice",
    "bottled-iced-milk",
    "bottled-mandarin-juice",
    "bottled-raspberry-juice",
    "bunny-cupcake",
    "burdock-celtuce-taco",
    "cappuccino",
    "capybara-cupcake",
    "carrot-juice",
    "cheese-crayfish-stuffed-crab-claws",
    "cheesy-baked-eggplants",
    "chocolate-mooncake",
    "cinnamoroll-crepe",
    "claypot-seafood-soup",
    "claypot-tomato-soup",
    "coconut-ice-cream",
    "coconut-juice",
    "coconut-pudding",
    "coffee-cupcake",
    "coffee-ice-cream",
    "coffee-pudding",
    "coffee-toast",
    "colorful-movie-meal",
    "corn-juice",
    "cozy-afternoon-tea",
    "cozy-borscht",
    "cozy-carrot-borscht",
    "cozy-corn-borscht",
    "cozy-potato-borscht",
    "cozy-tomato-borscht",
    "crayfish-avocado-cup",
    "cream-cake",
    "creamy-white-radish-soup",
    "cupcake",
    "deer-cupcake",
    "dragonfruit-jam",
    "eerie-pumpkin-bowl",
    "eerie-pumpkin-pie",
    "eerie-pumpkin-soup",
    "egg-dumpling",
    "egg-pudding",
    "egg-rice-bowl-banchos-pick",
    "eggplant-pasta",
    "ferret-cupcake",
    "fiddlehead-celtuce-taco",
    "fish-chips",
    "flat-white",
    "flower-cake",
    "fox-cupcake",
    "fried-shrimp-sushi-banchos-pick",
    "fruit-jam-meatball",
    "fruit-juice",
    "fruit-princess-cake",
    "glasswort-shrimp-fried-rice",
    "grape-cloud-candy",
    "grape-ice-cream",
    "grape-jam-meatball",
    "grape-juice",
    "grape-princess-cake",
    "grilled-mushroom",
    "grilled-shiitake",
    "grilled-squid-w-apple-jam",
    "grilled-squid-w-blueberry-jam",
    "grilled-squid-w-fruit-jam",
    "grilled-squid-w-pineapple-jam",
    "grilled-squid-w-starfruit-jam",
    "grilled-squid-w-strawberry-jam",
    "grimkin-pumpkin-bowl",
    "grimkin-pumpkin-pie",
    "grimkin-pumpkin-soup",
    "harvest-apple-yogurt-bowl",
    "harvest-black-diamond-mussel",
    "harvest-blue-diamond-mussel",
    "harvest-blueberry-yogurt-bowl",
    "harvest-corn-toast",
    "harvest-golden-mussel",
    "harvest-grape-yogurt-bowl",
    "harvest-jade-mussel",
    "harvest-lettuce-toast",
    "harvest-mandarin-yogurt-bowl",
    "harvest-matsutake-soup",
    "harvest-meal",
    "harvest-mussel",
    "harvest-nut-yogurt-bowl",
    "harvest-pineapple-yogurt-bowl",
    "harvest-purple-diamond-mussel",
    "harvest-raspberry-yogurt-bowl",
    "harvest-strawberry-yogurt-bowl",
    "harvest-tomato-toast",
    "ice-cream",
    "iced-cup-coffee",
    "iced-cup-latte",
    "jady-blue-jellyfish-tartare",
    "jady-green-jellyfish-tartare",
    "jady-jellyfish-tartare",
    "jady-purple-jellyfish-tartare",
    "kuromi-crepe",
    "large-chocolate-mooncake",
    "large-egg-yolk-mooncake",
    "large-moon-rabbit-snow-skin-mooncake",
    "mandarin-cake",
    "mandarin-cloud-candy",
    "mandarin-cupcake",
    "mandarin-frosted-pancake",
    "mandarin-ice-cream",
    "mandarin-jam-meatball",
    "mandarin-juice",
    "mandarin-pearl-cake",
    "mandarin-princess-cake",
    "mandarin-pudding",
    "marinated-catfish-fillets",
    "marinated-fillets",
    "marinated-paddlefish-fillets",
    "marinated-pufferfish-fillets",
    "mashed-potato",
    "meat-dumpling",
    "milk-cupcake",
    "milk-toast",
    "mixed-vegetable-puree",
    "mixed-vegetable-soup",
    "moon-rabbit-snow-skin-mooncake",
    "mooncake",
    "mummy-cat-drink",
    "mustard-greens-celtuce-taco",
    "my-melody-crepe",
    "new-year-fortune-fish",
    "ocean-feast",
    "ocean-iced-drink",
    "original-cloud-candy",
    "original-frosted-pancake",
    "panda-cupcake",
    "pasta",
    "pea-puree",
    "pea-soup",
    "persimmon-ruyi-cake",
    "pineapple-cloud-candy",
    "pineapple-ice-cream",
    "pineapple-jam-meatball",
    "pineapple-juice",
    "pineapple-princess-cake",
    "pineapple-pudding",
    "pink-memory",
    "pudding",
    "qiaoguo",
    "raspberry-cloud-candy",
    "raspberry-cupcake",
    "raspberry-frosted-pancake",
    "raspberry-ice-cream",
    "raspberry-jam-meatball",
    "raspberry-juice",
    "raspberry-pearl-cake",
    "raspberry-princess-cake",
    "raspberry-pudding",
    "raspberry-toast",
    "salsa-rippled-potato-chips",
    "savory-duo-bucket",
    "sea-grape-shiitake-chawanmushi",
    "sea-otter-cupcake",
    "seashell-pearl-cake",
    "simmered-claypot-soup",
    "small-xmas-cake",
    "springday-picnic-set",
    "springday-raspberry-black-tea",
    "starfruit-jam",
    "starfruit-pearl-cake",
    "starry-apple-donut",
    "starry-apple-mint-milk",
    "starry-blueberry-donut",
    "starry-blueberry-mint-milk",
    "starry-fruit-donut",
    "starry-fruit-mint-milk",
    "starry-grape-donut",
    "starry-grape-mint-milk",
    "starry-mandarin-donut",
    "starry-mandarin-mint-milk",
    "starry-meal",
    "starry-pineapple-donut",
    "starry-pineapple-mint-milk",
    "starry-raspberry-donut",
    "starry-raspberry-mint-milk",
    "starry-strawberry-donut",
    "starry-strawberry-mint-milk",
    "steak-w-mashed-white-radish",
    "steamed-cured-meat",
    "steamed-ribs-w-rice-powder",
    "strawberry-cloud-candy",
    "strawberry-ice-cream",
    "strawberry-jam-meatball",
    "strawberry-juice",
    "strawberry-princess-cake",
    "tall-mustard-celtuce-taco",
    "toast",
    "toasted-apple-marshmallow",
    "toasted-blueberry-marshmallow",
    "toasted-mandarin-marshmallow",
    "toasted-marshmallow",
    "toasted-pineapple-marshmallow",
    "toasted-raspberry-marshmallow",
    "toasted-strawberry-marshmallow",
    "tomato-juice",
    "tomato-seafood-soup",
    "treatsure-candy-roll-cake",
    "treatsure-crispy-roll-cake",
    "treatsure-jelly-roll-cake",
    "treatsure-jellybean-roll-cake",
    "treatsure-puff-roll-cake",
    "treatsure-roll-cake",
    "utopia-meal",
    "utopian-corn-hotdog",
    "utopian-grilled-sausage",
    "utopian-lettuce-hotdog",
    "utopian-original-hotdog",
    "utopian-tomato-hotdog",
    "waffle-apple-ice-cream",
    "waffle-blueberry-ice-cream",
    "waffle-grape-ice-cream",
    "waffle-mandarin-ice-cream",
    "waffle-pineapple-ice-cream",
    "waffle-raspberry-ice-cream",
    "waffle-strawberry-ice-cream",
    "waffle-vanilla-ice-cream",
    "wakame-meatball-soup",
    "whole-wheat-toast"
  ],
  "ingredient": [
    "egg",
    "butter",
    "meat",
    "cooking-oil",
    "any-failed-dish",
    "milk",
    "blue-sugar",
    "springday-brown-sugar",
    "cheese",
    "coffee-beans",
    "sweet-duo-bucket",
    "green-sugar",
    "indigo-sugar",
    "pasteurized-egg",
    "orange-sugar",
    "red-sugar",
    "salsa-sauce",
    "violet-sugar",
    "frosted",
    "yellow-sugar",
    "sugar",
    "matcha-powder",
    "red-bean",
    "rice-flour",
    "tea-leaves",
    "universal-ingredient",
    "alpaca-paw-candy",
    "beet",
    "bunny-paw-candy",
    "capybara-paw-candy",
    "cocoa-bean",
    "coconut",
    "cozy-classic-meatball",
    "cozy-custard-sauce",
    "deer-paw-candy",
    "edible-star-powder",
    "fermented-dough",
    "ferret-paw-candy",
    "fox-paw-candy",
    "frozen-sausage",
    "ghost-lollipop",
    "glasswort",
    "harvest-nuts",
    "harvest-yogurt",
    "marinade-powder",
    "marshmallow",
    "mint",
    "panda-paw-candy",
    "parsley",
    "pea",
    "persimmon",
    "potato",
    "pumpkin",
    "pumpkin-lollipop",
    "salsa",
    "sea-grape",
    "sea-otter-paw-candy",
    "spirulina-powder",
    "starfruit",
    "vanilla",
    "wakame",
    "white-dragonfruit"
  ],
  "vehicle": [
    "black-motorcycle",
    "black-sedan",
    "blue-sedan",
    "green-motorcycle",
    "pink-motorcycle",
    "pink-sedan",
    "red-motorcycle",
    "simplistic-mountain-bike",
    "white-convertible",
    "white-motorcycle",
    "yellow-sedan"
  ],
  "seed": [
    "anthurium-seeds",
    "calla-lily-seeds",
    "carnation-seeds",
    "corn-poppy-seeds",
    "cranesbill-seeds",
    "daisy-seeds",
    "highland-poppy-seeds",
    "hyacinth-seeds",
    "laceleaf-seeds",
    "lily-seeds",
    "morning-glory-seeds",
    "moth-orchid-seeds",
    "pansy-seeds",
    "pink-daisy-seed",
    "red-calla-lily-seed",
    "red-carnation-seed",
    "red-corn-poppy-seed",
    "red-daisy-seed",
    "red-highland-poppy-seed",
    "red-laceleaft-seed",
    "red-morning-glory-seed",
    "red-pansy-seed",
    "romaine-lettuce-seed",
    "rose-seeds",
    "tulip-seeds",
    "avocado-seed",
    "cacao-seed",
    "carrot-seed",
    "corn-seed",
    "eggplant-seed",
    "grape-seed",
    "lettuce-seed",
    "pineapple-seed",
    "potato-seed",
    "strawberry-seed",
    "tomato-seed",
    "wheat-seed",
    "white-calla-lily-seed",
    "white-carnation-seed",
    "white-corn-poppy-seed",
    "white-daisy-seed",
    "white-highland-poppy-seed",
    "white-laceleaft-seed",
    "white-morning-glory-seed",
    "white-radish-seed",
    "yellow-calla-lily-seed",
    "yellow-carnation-seed",
    "yellow-corn-poppy-seed",
    "yellow-highland-poppy-seed",
    "yellow-laceleaft-seed",
    "yellow-morning-glory-seed",
    "yellow-pansy-seed",
    "black-calla-lily-seed",
    "black-cranesbill-seed",
    "black-rose-seed",
    "black-tulip-seed",
    "blue-cranesbill-seed",
    "blue-rose-seed",
    "blue-tulip-seed",
    "glass-rose-seed",
    "green-cranesbill-seed",
    "orange-calla-lily-seed",
    "orange-cranesbill-seed",
    "orange-rose-seed",
    "orange-tulip-seed",
    "peach-calla-lily-seed",
    "peach-cranesbill-seed",
    "peach-rose-seed",
    "peach-tulip-seed",
    "pink-calla-lily-seed",
    "pink-cranesbill-seed",
    "pink-rose-seed",
    "pink-tulip-seed",
    "purple-calla-lily-seed",
    "purple-rose-seed",
    "purple-tulip-seed",
    "red-cranesbill-seed",
    "red-rose-seed",
    "red-tulip-seed",
    "selene-cranesbill-seed",
    "selene-rose-seed",
    "sunglow-calla-lily-seed",
    "sunglow-cranesbill-seed",
    "sunglow-rose-seed",
    "sunglow-tulip-seed",
    "white-cranesbill-seed",
    "white-rose-seed",
    "white-tulip-seed",
    "yellow-cranesbill-seed",
    "yellow-rose-seed",
    "yellow-tulip-seed"
  ],
  "tool": [
    "auto-bird-whistle",
    "axe",
    "bait",
    "camouflage-bush",
    "crafty-repair-kit",
    "dye",
    "fertilizer",
    "fishing-rod",
    "free-spirited-coffee-umbrella",
    "growth-booster",
    "amazing-seasoning",
    "cat-food",
    "dog-food",
    "insect-net",
    "master-repair-kit",
    "mermaid-fish-attractor",
    "mermaid-perfume",
    "quality-fertilizer",
    "quality-growth-booster",
    "rainbow-bouquet",
    "rainbow-breeding-powder",
    "repair-kit",
    "scanner",
    "tablet",
    "top-fertilizer",
    "top-growth-booster",
    "universal-animal-food",
    "inflatable-insect-attractor",
    "sense-booster",
    "watering-can"
  ],
  "furniture": [
    "dreamlight-cinematics-popcorn-serving-cart",
    "large-flower-bed",
    "large-vivarium",
    "medium-flower-bed",
    "medium-vivarium",
    "medium-wall-plant-frame",
    "planter",
    "small-flower-bed",
    "small-vivarium",
    "square-flower-bed"
  ],
  "material": [
    "loam",
    "ore",
    "snowball",
    "starfall-shard"
  ]
};

export const ITEM_IDS_BY_EVENT_KEY: Record<string, string[]> = {
  "sea-fishing": [
    "anglerfish",
    "common-octopus",
    "european-flying-squid",
    "giant-oarfish",
    "golden-king-crab",
    "moonfish",
    "nursehound",
    "shortfin-mako-shark",
    "striped-red-mullet",
    "turbot",
    "whale-shark",
    "moon-jelly"
  ],
  "frostspore-fish": [
    "frostspore-king-crab",
    "frostspore-ocean-sunfish",
    "frostspore-puffer-fish",
    "frostspore-seahorse",
    "frostspore-whale-shark"
  ],
  "bait-the-insects": [
    "apollo",
    "chestnut-tiger",
    "pink-katydid",
    "postman-butterfly",
    "white-witch"
  ],
  "frostspore-butterfly-spirit-oak-pine-forest-forest-jump-puzzle": [
    "frostspore-mother-of-pearl"
  ],
  "frostspore-butterfly": [
    "frostspore-postman-butterfly",
    "frostspore-sulkowskys-morpho"
  ],
  "frostspore-butterfly-spirit-oak-pine-forest": [
    "frostspore-purple-spotted-swallowtail"
  ],
  "frostspore-butterfly-deer-tower": [
    "frostspore-queen-alexandras-birdwing"
  ],
  "bait-the-insects-ruins": [
    "rainbow-stag-beetle"
  ],
  "nest-of-hundreds": [
    "blue-and-yellow-macaw",
    "blue-peafowl",
    "great-green-macaw",
    "lears-macaw",
    "red-and-green-macaw",
    "green-peafowl",
    "white-peafowl",
    "black-peafowl"
  ],
  "winter-birdwatching-suburban-lake": [
    "winter-eurasian-wigeon",
    "winter-greater-flamingo",
    "winter-mallard",
    "winter-smew"
  ],
  "winter-birdwatching": [
    "winter-mandarin-duck"
  ],
  "winter-frost-season-old-sea": [
    "penguin"
  ],
  "dreamlight-cinematics": [
    "dreamlight-cinematics-popcorn-serving-cart",
    "springdag-raspberry-black-tea",
    "springday-apple-black-tea",
    "springday-blueberry-black-tea",
    "springday-fruit-black-tea",
    "springday-grape-black-tea",
    "springday-mandarin-black-tea",
    "springday-pineapple-black-tea",
    "springday-strawberry-black-tea",
    "supreme-movie-meal",
    "blue-suit-dove",
    "gray-suit-dove",
    "striped-suit-dove",
    "red-suit-dove",
    "green-suit-dove",
    "director-common-octopus-with-patterned-hat",
    "golden-script-supervisor-bumblebee"
  ],
  "modular-streets": [
    "apple-verbena-pie",
    "blueberry-verbena-pie",
    "brick-black-truffle-patty-burger",
    "brick-bowl-apple-shaved-ice",
    "brick-bowl-blueberry-shaved-ice",
    "brick-bowl-fruit-shaved-ice",
    "brick-bowl-grape-shaved-ice",
    "brick-bowl-mandarin-shaved-ice",
    "brick-bowl-pineapple-shaved-ice",
    "brick-bowl-raspberry-shaved-ice",
    "brick-bowl-strawberry-shaved-ice",
    "brick-button-mushroom-patty-burger",
    "brick-fun-combo-set",
    "brick-mushroom-patty-burger",
    "brick-oyster-mushroom-patty-burger",
    "brick-penny-bun-patty-burger",
    "brick-shiitake-patty-burger",
    "fruit-verbena-pie",
    "grape-verbena-pie",
    "mandarin-verbena-pie",
    "pineapple-verbena-pie",
    "raspberry-verbena-pie",
    "strawberry-verbena-pie",
    "blue-brick-sparrow",
    "purple-brick-sparrow",
    "colorful-brick-sparrow",
    "pink-brick-sparrow",
    "green-brick-sparrow",
    "yellow-brick-large-red-damselfly",
    "blue-brick-large-red-damselfly",
    "purple-brick-large-red-damselfly",
    "colorful-brick-large-red-damselfly",
    "pink-brick-large-red-damselfly",
    "blue-brick-clownfish",
    "colorful-brick-clownfish",
    "purple-brick-clownfish",
    "red-brick-clownfish",
    "green-brick-clownfish"
  ],
  "maltese": [
    "heart-puppies-con-panna",
    "maltese-canele",
    "maltese-con-panna",
    "retriever-canele",
    "retriever-con-panna"
  ],
  "midsummer-rhyme": [
    "pillow-shaped-egg-yolk-and-pork-zongzi",
    "pillow-shaped-plain-rice-zongzi",
    "pillow-shaped-red-bean-zongzi",
    "triangle-egg-yolk-and-pork-zongzi",
    "triangle-plain-rice-zongzi",
    "triangle-red-bean-zongzi"
  ],
  "rainbow-verse": [
    "rainbow-heart",
    "rainbow-spark"
  ],
  "winter-frost-season": [
    "snowball"
  ]
};

export const ALIAS_TO_CANONICAL_ID: Record<string, string> = {
  "bizarre-drink": "bizzare-drink",
  "baked-eggplant-with-meat": "baked-eggplant-w-meat",
  "cheesecake": "cheese-cake",
  "posteurized-egg": "pasteurized-egg",
  "branches": "branch",
  "blueberries": "blueberry",
  "repair-kits": "repair-kit",
  "redpolis": "redpoll",
  "bizarre-ogster-mushroom-orange": "bizarre-oyster-mushroom-orange",
  "bizarre-ogster-mushroom-pink": "bizarre-oyster-mushroom-pink",
  "bizarre-ogster-mushroom-purple": "bizarre-oyster-mushroom-purple",
  "bizarre-shiitak-black": "bizarre-shiitake-black"
};

/** Resolves an id that might be an alias to its canonical item, or undefined if unknown. */
export function resolveItem(idOrAlias: string) {
  const canonicalId = ALIAS_TO_CANONICAL_ID[idOrAlias] ?? idOrAlias;
  return ITEMS_BY_ID[canonicalId];
}
